import { Stack } from '@mui/material';
import { classnames } from '@aibees/shared/utils';
import { memo } from 'react';
import { useWhiteLabelContext } from '@aibees/elephant/feature/white-label/context';
import * as Styled from './styles';
import * as SX from './sx';
import type { LoadingPreviewProps as Props } from './types';

export const LoadingPreview = memo(({ className }: Props) => {
  const { loaderLogo } = useWhiteLabelContext();

  const logoUrl = loaderLogo.value
    ? URL.createObjectURL(loaderLogo.value as any)
    : null;

  return (
    <Styled.Wrapper
      className={classnames('LoadingPreview', className)}
      title="Loading ..."
      description="70px X 70px"
      tooltipContent="Recommended dimensions: 70px by 70px. This icon appears while the page is loading."
    >
      <Stack justifyContent="center" alignItems="center" sx={SX.container}>
        {logoUrl ? (
          <img src={logoUrl} alt="Logo" />
        ) : (
          <Styled.Container>
            <Stack sx={SX.content}>
              <Styled.Logo src="/assets/images/ark-logo.svg" alt="logo" />
            </Stack>
          </Styled.Container>
        )}
      </Stack>
    </Styled.Wrapper>
  );
});

LoadingPreview.displayName = 'LoadingPreview';
